import CustomTable from "Components/CustomTable/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { RenderCreated, RenderUpdated, RenderActionButtons, getCommonColumns } from "Components/CustomTable/Commons";
import AddEditForm from "Components/Forms/Master/Languages/AddEditForm";
import getPermittedColumns from "Utils/getPermittedColumns";

const apiUrl = "/language/rest/languages";
const headerTitle = "Languages";
const editPermission = "languages:edit";
const deletePermission = "languages:delete";
const addPermission = "languages:add";

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        // render: (text) => <a>{text}</a>,
    },
    {
        title: 'ISO 639 1',
        dataIndex: 'country_code',
        key: 'country_code',
        // render: (text) => <a>{text}</a>,
    },
    {
        title: 'Language Code',
        dataIndex: 'language_code',
        key: 'language_code',
        // render: (text) => <a>{text}</a>,
    },
    ...getCommonColumns({ apiUrl, editPermission, deletePermission, created: true, updated: true, action: true })
];

const LanguagesPage = () => {

    const userPermissions = useSelector(store => store.auth?.user?.permissions);
    let _columns = getPermittedColumns(columns, userPermissions, editPermission, deletePermission);

    return <CustomTable
        columns={_columns}
        apiUrl={apiUrl}
        headerTitle={headerTitle}
        MyFormComponent={AddEditForm}
        addPermissionNames={[addPermission]}
    />;
}

export default LanguagesPage;